/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon16Light = forwardRef('MathSumIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.285 3.464C2.73 2.934 3.105 2 3.872 2H12.5a.5.5 0 0 1 0 1H4.246l4.585 4.386a.85.85 0 0 1 0 1.228L4.246 13H12.5a.5.5 0 0 1 0 1H3.872c-.766 0-1.141-.934-.587-1.464L8.027 8 3.285 3.464Z" })));
});
